import { Main } from '../styled';
import EmployeeOverview from './components/employe-overview';
import Time from './components/time';
import AttendanceRule from './components/attendance-rule';
import MonthlyAttendance from './components/monthly-attendance';
import Performance from './components/performance';
import LeadFunnelPerformance from './components/lead-funnel-performance';
import AdministratorForm from './components/administrator-form';

function BlankPage() {
  return (
    <>
      <Main>
        <div className="dashboard-work-row">
          <div className="dashboard-work-item">
            <EmployeeOverview />
            <AttendanceRule />
          </div>
          <div className="dashboard-work-time">
            <Time />
          </div>
          <div className="dashboard-work-attendance">
            <MonthlyAttendance />
            <div className="dashboard-work-performance">
              <Performance />
              <div className="dashboard-work-performance-item">
                <LeadFunnelPerformance />
                <AdministratorForm />
              </div>
            </div>
          </div>
        </div>
      </Main>
    </>
  );
}

export default BlankPage;
